import Labelling from './src/main';

/* istanbul ignore next */
Labelling.install = function(Vue) {
  Vue.component(Labelling.name, Labelling);
};

export default Labelling;
